import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Button, Callout, Row } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './BiometricNudgeBanner.module.scss';
import { useBiometricNudge } from './hooks/useBiometricNudge';
export const GetBiometricNudgeBannerTID = (parentTestId)=>getTestIds(parentTestId);
export function BiometricNudgeBanner() {
    const { t: homeTexts } = useLocaleKeys('home.homePage');
    const { BiometricNudgeBannerTID } = useMemo(()=>GetBiometricNudgeBannerTID(), []);
    const { shouldShow, method, loading, enroll, dismiss } = useBiometricNudge();
    if (!shouldShow) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.container,
        children: /*#__PURE__*/ _jsx(Callout, {
            hideIcon: true,
            intent: "info",
            testId: BiometricNudgeBannerTID.Root(),
            classes: {
                wrapper: styles.calloutWrapper,
                main: styles.calloutMain
            },
            withAction: /*#__PURE__*/ _jsxs(Row, {
                alignItems: "center",
                gap: 8,
                className: styles.buttons,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        size: "small",
                        testId: BiometricNudgeBannerTID.EnableButton(),
                        skin: "primary",
                        loading: loading,
                        onClick: enroll,
                        bi: {
                            name: 'biometric_nudge_enable'
                        },
                        children: homeTexts.biometricNudgeEnable({
                            method
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        size: "small",
                        skin: "primaryOutline",
                        onClick: dismiss,
                        testId: BiometricNudgeBannerTID.DismissButton(),
                        bi: {
                            name: 'biometric_nudge_dismiss'
                        },
                        children: homeTexts.biometricNudgeDismiss()
                    })
                ]
            }),
            children: homeTexts.biometricNudgeDescription({
                method
            })
        })
    });
}
